import * as Core from '@skylab-shared/core';
import { CalculationMethod } from '../common/calculation-method';
import { SaleDocumentKind } from './sale-document-kind';


export class SaleKindModel extends Core.ModelBase {
    @Core.Property()
    public adjustment: boolean;

    @Core.Property({ nullable: true })
    public adjustmentDefaultDueDate: number;

    @Core.Property({ nullable: true })
    public adjustmentDefaultPaymentMethodId: number;

    @Core.Property()
    public automaticallyAddPayment: boolean;

    @Core.Property()
    @Core.Required('data-model.document-configuration.validation.custom-transaction-location.empty')
    @Core.ShortString('data-model.document-configuration.validation.custom-transaction-location.length')
    public customTransactionLocation: string;

    @Core.Property()
    public defaultCalculationMethod: CalculationMethod;

    @Core.Property()
    @Core.Range({ min: 0 }, 'data-model.document-configuration.validation.default-due-date.range')
    public defaultDueDate: number;

    @Core.Property()
    public defaultNumberingId: number;

    @Core.Property({ nullable: true })
    public defaultAdjustmentNumberingId?: number;

    @Core.Property({ nullable: true })
    public defaultMarginSchemeId: number;

    @Core.Property()
    public defaultPaymentMethodId: number;

    @Core.Property({ identifiable: true })
    public name: SaleDocumentKind;

    @Core.Property()
    public useCustomTransactionLocation: boolean;
}
